import moment from 'moment';
/*
 * Returns date boundary according to other date,
 * If date is invalid and boundary is strictly required (ie. max date), limit will use actual date
 */
export function  getValidDateBoundary(date = null, isRequired = false) {
  //Clone implicit by creating new moment from moment object - https://momentjs.com/docs/#/parsing/moment-clone/
  return moment(date).isValid() ? moment(date) : isRequired ? moment() : null;
}

